module.exports = __webpack_public_path__ + "static/media/elt.2df62a1e.png";